import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import DisplayCard from './DisplayCard';

const Block = (props) => {
  const { statusID, firstStatusName, secondStatusName } = props.data;
  const {
    status,
    handleQuickStatus,
    batchedCount,
    batchedLoading,
  } = props;

  const [selected, setSelected] = useState(false);

  useEffect(() => {
    let quickStatus = statusID.map(String);
    if (JSON.stringify(status) !== JSON.stringify(quickStatus)) {
      setSelected(false);
    } else {
      setSelected(true);
    }
  }, [status, statusID]);

  const handleClick = () => {
    setSelected(true);
    handleQuickStatus(statusID);
  };

  const displayCount = batchedCount == null ? '—' : batchedCount;

  return (
    <DisplayCard
      tertiaryText={secondStatusName}
      secondaryText={firstStatusName}
      primaryText={displayCount}
      loading={batchedLoading}
      selected={selected}
      handleClick={handleClick}
    />
  );
};

export default Block;
